import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import CustomTooltip from '../../../Tooltip';
import PreviewOriginal from '../../../PreviewOriginal';
import { useTemplateConfig } from '../../../../context/TemplateConfigContext';
import DataComponentPromo from "../../../DataComponent/DataComponentPromo";

const columnTableData = {
    header: {
        0: {className: 'text-center', style: {width: 50}},
        1: {className: 'offer-item__table-banner', style: {width: 187}},
        2: {className: 'text-center'},
        3: {className: 'text-center'}
    },
    body: {
        0: {className: 'text-center'},
        1: {className: 'offer-item__table-banner'}
    }
};

const OfferPagePromoContainers = ({ 
    params, 
    containers, 
    locales, 
    headerNames, 
    loading, 
    totalPages, 
    getLocales, 
    showConstructor, 
    getContainers, 
    t 
}) => {
    const { assets } = useTemplateConfig();
    const [state, setState] = useState({
        offerId: (params && params.id) || null,
        containers: containers,
        locales: locales,
        headerNames: headerNames,
        loading: loading,
        totalPages: totalPages
    });

    useEffect(() => {
        getLocales(state);
    }, []);

    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            loading: loading,
            containers: containers,
            locales: locales,
            totalPages: totalPages
        }));
    }, [loading, containers, locales, totalPages]);

    const showConstructorHandler = useCallback((index) => {
        const staticNames = t?.constructors || {};
        let data = state.containers[index];

        if (showConstructor) {
            showConstructor({
                creativeType: 'container',
                creativeId: data.id,
                linkId: data.link.id,
                type: 'container',
                codeParams: {
                    width: data.width,
                    height: data.height,
                    text: staticNames.textIframe
                }
            });
        }
    }, [state.containers, showConstructor, t]);

    const getContainersData = useCallback(() => {
        let containersData = [];
        let staticNames = t?.offersPage?.offer || {};

        state.containers.map((container, i) => {
            let itemUrl = container.link.url.slice(0, 60);
            if (itemUrl.length < container.link.url.length) {
                itemUrl += '...';
            }

            let itemTitle = container.link.title.slice(0,50);
            if (itemTitle.length < container.link.title.length) {
                itemTitle += '...';
            }

            containersData.push({
                id: container.id,
                name: container.link.title,
                image: (
                    <div className="offer-item__table-img">
                        {container.link.thumbnail
                            ? (
                                <CustomTooltip id={`link-preview-${i}`} tooltip={<PreviewOriginal url={container.link.image} />} placement={'right'} theme={'preview'}>
                                    <a href={container.link.url} id={`link-preview-${i}`} target="_blank">
                                        <img src={container.link.thumbnail || assets.cap} alt="" />
                                    </a>
                                </CustomTooltip>
                            )
                            : (
                                <a href={container.link.url} target="_blank">
                                    <img src={assets.cap} alt="" />
                                </a>
                            )
                        }
                    </div>
                ),
                title: itemTitle,
                url:(<a href={container.link.url} target="_blank">{itemUrl}</a>),
                action: (
                    <div className="offer-item__promo-links-wrap">
                        <div className="offer-item__promo-links-toolbar">
                            <button
                                className="btn btn-white generate-link"
                                onClick={() => { showConstructorHandler(i); }}
                            >
                                {staticNames.generateContainer}
                            </button>
                        </div>
                    </div>
                )
            });
        });

        return containersData;
    }, [state.containers, showConstructorHandler, t]);

    const onDataTableAction = useCallback((state, actionType) => {
        getContainers({
            ...state,
            offer_ids: state.offerId
        }, actionType);
    }, [getContainers, state.offerId]);

    const containersData = useMemo(() => getContainersData(), [getContainersData]);

    return (
        <DataComponentPromo
            onAction={onDataTableAction}
            totalPages={state.totalPages}
            headerNames={state.headerNames}
            data={containersData}
            loading={state.loading}
            withoutDatepicker={true}
            textInput={true}
            alignPagination={true}
            columnData={columnTableData}
            hidden={true}
        />
    );
};

OfferPagePromoContainers.propTypes = {
    params: PropTypes.object,
    containers: PropTypes.array,
    locales: PropTypes.array,
    headerNames: PropTypes.array,
    loading: PropTypes.bool,
    totalPages: PropTypes.number,
    getLocales: PropTypes.func,
    showConstructor: PropTypes.func,
    getContainers: PropTypes.func,
    t: PropTypes.object
};

OfferPagePromoContainers.defaultProps = {
    containers: [],
    locales: [],
    headerNames: [],
    loading: false,
    totalPages: 0,
    getLocales: () => {},
    showConstructor: () => {},
    getContainers: () => {}
};

export default withTranslation(OfferPagePromoContainers);